
import { Dropdown } from 'bootstrap';


const b2bTypeahead = {
  props: {
    get: Function,           // fonction pour le typeahead k=> array
    placeholder: String,     // placehoder du input
  },
  data() {
    return {
      dropdown: null,
      timeout: null,
      debouncedInput: '',

      items: [],
      index: 0,
      cache: {},
    }
  },

  mounted() {
    const { el, input } = this.$refs;
    this.input = input;

    this.dropdown = new Dropdown(el, {
      autoClose: true,
    });
    el.addEventListener("hide.bs.dropdown", () => {
      this.debouncedInput = "";
    })
    
  },
  computed: {
    search: {
      get() {
        return this.debouncedInput
      },
      set(val) {
        if (this.timeout) clearTimeout(this.timeout);
        if (val == "") {
          this.debouncedInput = "";
          this.change(val);
        } else {
          this.timeout = setTimeout(() => {
            //
            this.debouncedInput = val;
            this.change(val);
          }, 300)
        }
      }
    }
  },
  methods: {
    click: function (item) {
      //
      this.$emit("select", item);
      //
      this.search = "";
      this.input.focus();
    },
    change: async function (value) {
      const text = value || "";

      if (text == "") {
        this.items = [];
        this.dropdown.hide();        
      } else {
        let result;
        //
        if (text in this.cache) {
          result = this.cache[text];
        } else {
          result = await this.get(text);
          this.cache[text] = result;
        }
        //
        this.items = result;
        this.index = 0;
        this.dropdown.show();
      }
    },
    enter: function () {
      if (this.items[this.index]) this.click(this.items[this.index]);
    },
    next: function () {
      if (this.index < this.items.length - 1) this.index++;
    },
    previous: function () {
      if (this.index > 0) this.index--;
    },
  },
  template:
    // @keyup.enter="enter" @click="click(item)"  @click="click(item)" 
    // @moche focus sur ligne 
    `
		<div class="dropdown">

			<div class="input-group input-group-md input-group-merge input-group-reverse"  >			  
			  <input ref="input" type="text"  class="form-control list-search"  :placeholder="(placeholder)? placeholder :'Search'" @keyup.enter="enter" v-model="search"   @keyup.down.stop="next" @keyup.up.stop="previous">
			  <span class="input-group-text"><i class="fe fe-search"></i></span>
			</div>

			
			<div href="#" ref="el"  data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="background-color:blue">
			</div>
			<div class="dropdown-menu" style="width:100%; max-height: 20rem !important;  overflow-y: auto;" >
				<slot name="header"> </slot>
				
				<div  class="dropdown-item" @click="click(item)"  :class="{active: i==index }" v-for="(item,i) of items">
				  <div class="fw-normal row main"><span class="col-auto w-30 ">{{item.vth || item.v}}</span> </div>    
				</div>   
				 
				<div class="dropdown-item"  @click="click(item)"  v-if="items.length==0">
				  <div class="fs-5"> No result </div>
				</div>   
				
				
				<slot name="footer"></slot>
			</div>
	   </div>`
};
export default b2bTypeahead;

